import {MediaBrowserPanelTrackingContextState} from '../MediaBrowserPanelTrackingContext';

export type TrackingStage = {
  startTime: number;
  duration: number;
};

export type TrackingStages = {
  processing: TrackingStage;
  files: TrackingStage;
  urls: TrackingStage;
  cache: TrackingStage;
  load: TrackingStage;
};

export type TrackingState = {
  componentCreatedMs: number;
  availableFilesReceivedMs: number;
  directUrlReceivedMs: number;
  dataCachedMs: number;
  mediaLoadedMs: number;
  panel: MediaBrowserPanelTrackingContextState;
};

export function calculateTrackingStages(
  state: TrackingState
): TrackingStages | null {
  if (!state.mediaLoadedMs || !state.panel?.startTimeMs) {
    return null;
  }

  const panelStartTime = state.panel.startTimeMs;

  // Calculate relative start times
  const tileRelativeStartTimeFiles = state.componentCreatedMs - panelStartTime;
  const tileRelativeStartTimeUrls =
    state.availableFilesReceivedMs - panelStartTime;
  const tileRelativeStartTimeCache = state.directUrlReceivedMs - panelStartTime;
  const tileRelativeStartTimeLoad = state.dataCachedMs - panelStartTime;

  // Calculate durations
  const tileDurationProcessing = state.componentCreatedMs - panelStartTime;
  const tileDurationFiles =
    state.availableFilesReceivedMs - state.componentCreatedMs;
  const tileDurationUrls =
    state.directUrlReceivedMs - state.availableFilesReceivedMs;
  const tileDurationCache = state.dataCachedMs - state.directUrlReceivedMs;
  const tileDurationLoad = state.mediaLoadedMs - state.dataCachedMs;

  return {
    // NOTE: this lumps a good bit of work into "processing"
    // TODO: add more granular stages for processing to identify where we spend time
    processing: {
      startTime: 0,
      duration: tileDurationProcessing,
    },
    files: {
      startTime: tileRelativeStartTimeFiles,
      duration: tileDurationFiles,
    },
    urls: {
      startTime: tileRelativeStartTimeUrls,
      duration: tileDurationUrls,
    },
    cache: {
      startTime: tileRelativeStartTimeCache,
      duration: tileDurationCache,
    },
    load: {
      startTime: tileRelativeStartTimeLoad,
      duration: tileDurationLoad,
    },
  };
}

export function calculateTotalDuration(state: TrackingState): number | null {
  if (!state.mediaLoadedMs || !state.panel?.startTimeMs) {
    return null;
  }
  return state.mediaLoadedMs - state.panel.startTimeMs;
}
